/* eslint-disable react/no-array-index-key */

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import React, { PureComponent } from 'react';

import { NavigationList, List, Item, Name, Description, DescriptionValue } from './styles';

export default class CheckoutNavigatorList extends PureComponent {
    render() {
        const { navigationPages, navigatorName, pageNames, naviData } = this.props;

        return (
            <NavigationList>
                <List>
                    {navigationPages.map((page, index) => (
                        <Item
                            key={index}
                            passed={index < pageNames.indexOf(navigatorName)}
                            passedLast={index === pageNames.indexOf(navigatorName) - 1}
                            active={navigatorName === page.name}
                        >
                            <Name
                                passed={index < pageNames.indexOf(navigatorName)}
                                active={navigatorName === page.name}
                            >
                                <Translator tk={page.title} />
                            </Name>
                            {
                                <Description passed={index < pageNames.indexOf(navigatorName)}>
                                    {!!naviData[page.name] &&
                                        naviData[page.name].map((value, i) => (
                                            <DescriptionValue key={i}>
                                                <Translator tk={value} />
                                            </DescriptionValue>
                                        ))}
                                </Description>
                            }
                        </Item>
                    ))}
                </List>
            </NavigationList>
        );
    }
}
